import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpContext, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '@6grain/masofa-monolith-api-client/dictionaries/api.base.service';
import { Configuration } from '@6grain/masofa-monolith-api-client/dictionaries/configuration';
import { BASE_PATH } from '@6grain/masofa-monolith-api-client/dictionaries/variables';
import { BidWorkType } from './bidWorkType';

/** Local shim until @6grain/masofa-monolith-api-client tag includes BidWorkTypeService. */
@Injectable({
  providedIn: 'root',
})
export class BidWorkTypeService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  public dictionariesBidWorkTypeGetByQueryPost(
    body?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<BidWorkType>>;
  public dictionariesBidWorkTypeGetByQueryPost(
    body?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<BidWorkType>>>;
  public dictionariesBidWorkTypeGetByQueryPost(
    body?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<BidWorkType>>>;
  public dictionariesBidWorkTypeGetByQueryPost(
    body?: object,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/dictionaries/BidWorkType/GetByQuery`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<BidWorkType>>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body ?? {},
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe,
      transferCache: localVarTransferCache,
      reportProgress,
    });
  }
}
